/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'

import {
  Button, Row, Col, Form, Collapse, Input, message, Select, DatePicker, Space,
} from 'antd'

import { CloseOutlined, SearchOutlined } from '@ant-design/icons'

import { fetch } from '../../../utils/fetch'

const { Panel } = Collapse
const { Option } = Select

const UserFilter = ({ onSearch }) => {
  const [form] = Form.useForm()
  const [siteList, setSiteList] = useState([])
  const [roleList, setRoleList] = useState([])

  const fetchSite = () => {
    fetch({
      url: '/master/site',
    }).then((res) => {
      if (res.data?.success) {
        setSiteList(res.data?.data)
      }
    })
  }

  const fetchRole = () => {
    fetch({
      url: '/master/role',
    }).then((res) => {
      if (res.data?.success) {
        setRoleList(res.data?.data)
      }
    })
  }

  useEffect(() => {
    fetchSite()
    fetchRole()
  }, [])

  const onClickSearch = () => {
    form.validateFields()
      .then((values) => {
        onSearch(values)
      })
      .catch((info) => {
        message.error('Order filter validate failed!')
        console.log('Order filter validate failed:', info)
      })
  }

  const onClickClearFilter = () => {
    form.resetFields()
    onSearch(null)
  }

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['0']}
      >
        <Panel
          header="Filter"
          key="1"
          style={{
            background: '#f7f7f7',
            borderRadius: 4,
            border: 0,
            overflow: 'hidden',
          }}
          extra={(
            <Button
              type="link"
              size="small"
              onClick={() => { onClickClearFilter() }}
            >
              <CloseOutlined />
              Clear Filter
            </Button>
          )}
        >
          <Form
            form={form}
            name="order_filter"
            layout="vertical"
          >
            <Row gutter={24}>
              <Col xs={24} md={8}>
                <Form.Item label="Username" name="username">
                  <Input
                    allowClear
                    placeholder="Username"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item label="First Name" name="firstName">
                  <Input
                    allowClear
                    placeholder="First Name"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item label="Last Name" name="lastName">
                  <Input
                    allowClear
                    placeholder="Last Name"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={24} md={8}>
                <Form.Item label="Site" name="siteCode">
                  <Select
                    placeholder="Select a site"
                    allowClear
                  >
                    {
                      siteList.length > 0
                        ? siteList.map((site) => <Option key={`select-site-${site.siteCode}`} value={site.siteCode}>{site.siteCode} - {site.siteDescr}</Option>)
                        : <Option value="" />
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="roleCode" label="Role">
                  <Select 
                    mode="multiple" 
                    placeholder="Please select role">
                    {
                      roleList.length > 0
                        ? roleList.map((role) => <Option key={`select-role-${role.roleCode}`} value={role.roleCode}>{role.roleDescr}</Option>)
                        : <Option value="" />
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item label="Status" name="isActive">
                  <Select
                    allowClear
                    placeholder="Select Status"
                    defaultValue={null}
                  >
                    <Option value={null}>All</Option>
                    <Option value="1">Success</Option>
                    <Option value="0">Error</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row>
            <Button
              type="primary"
              style={{ width: '100%' }}
              onClick={() => { onClickSearch() }}
            >
              <SearchOutlined />
              Search
            </Button>
          </Row>
        </Panel>
      </Collapse>
    </>
  )
}

export default UserFilter

